const RadioButtonComponentLandscapes = ({
    selectedOption,
    onSelectOption,
    options,
    className,
    disabled,
    inputClassName,
}) => {
    const handleOptionChange = (option) => {
        onSelectOption(option);
    };

    return (
        <div className={`flex  gap-3 ${className}`}>
            {options.map((option, i) => {
                console.log(option, 'see the option');
                return (
                    <label className="cursor-pointer flex items-center" key={option?.name + i}>
                        <input
                            type="radio"
                            disabled={disabled}
                            value={option?.name}
                            checked={selectedOption === option?.name}
                            onChange={() => handleOptionChange(option)}
                            className={`hidden ${inputClassName}`}
                        />
                        <span className="bg-[#B4D1CD] rounded-full p-2">
                            <span
                                className={`w-4 h-4 border-2 border-[#1E6D4E] rounded-full flex items-center justify-center`}
                            >
                                <span
                                    className={`w-2 h-2 bg-[#1E6D4E] rounded-full ${
                                        selectedOption?.chainName +
                                            (selectedOption?.chainName === 'solana'
                                                ? selectedOption?.collectionAddress
                                                : selectedOption?.contractAddress) +
                                            selectedOption?.tokenId ===
                                        option?.chainName +
                                            (option?.chainName === 'solana'
                                                ? option?.collectionAddress
                                                : option?.contractAddress) +
                                            option?.tokenId
                                            ? 'block'
                                            : 'hidden'
                                    }`}
                                ></span>
                            </span>
                        </span>
                        <span className="flex items-center  w-full justify-between gap-2">
                            <span className="capitalize ml-2 text-sm text-[#11413A] ">
                                {option?.name} -{' '}
                                {(
                                    Number(option?.nftProgress?.progress / option?.nftProgress?.nftEvolutionThreshold) *
                                    100
                                )?.toFixed(2)}
                                %
                            </span>
                            <img className="w-4 h-4" src={option?.chainImage} alt="" />
                        </span>
                    </label>
                );
            })}
        </div>
    );
};

export default RadioButtonComponentLandscapes;
